import { Box, Divider } from '@mui/material';

import { SystemResponseItem as SystemResponseItemType } from '../types';
import { CLIEmptyState } from './CliEmptyState';
import { SystemResponseItem } from './SystemResponseItem';

interface SystemResponseListProps {
  responses: SystemResponseItemType[];
}

export const SystemResponseList = ({ responses }: SystemResponseListProps) => {
  if (responses.length === 0) {
    return <CLIEmptyState />;
  }

  return (
    <Box mt={3}>
      <Divider sx={{ mb: 2 }} />
      <Box
        sx={{
          maxHeight: '188px',
          overflowY: 'auto',
          display: 'flex',
          flexDirection: 'column',
          gap: 1.5,
        }}
      >
        {responses.map((response) => (
          <SystemResponseItem
            key={response.id}
            type={response.type}
            message={response.message}
            date={response.date}
            data={response.data}
          />
        ))}
      </Box>
    </Box>
  );
};
